import { render } from "./BoardingPlace.vue?vue&type=template&id=08d7e6cc&scoped=true"
import script from "./BoardingPlace.vue?vue&type=script&lang=js"
export * from "./BoardingPlace.vue?vue&type=script&lang=js"

import "./BoardingPlace.vue?vue&type=style&index=0&id=08d7e6cc&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d7e6cc"]])

export default __exports__